import { createEnumParam, StringParam, useQueryParams, withDefault } from 'use-query-params';

import { AgreementReadModelSort, SortOrder } from '@client/api';

export const useAgreementListSearchQueryParams = () => {
  const result = useQueryParams({
    agreementsSearch: StringParam,
  });

  return result;
};

export const useAgreementListSortQueryParams = () => {
  const result = useQueryParams({
    agreementsSortProperty: withDefault<AgreementReadModelSort | undefined | null, AgreementReadModelSort>(
      createEnumParam(['Default', 'Status', 'Start', 'End', 'TenantName', 'Name']),
      'Default',
    ),
    agreementsSortOrder: withDefault<SortOrder | undefined | null, SortOrder>(createEnumParam(['Asc', 'Desc']), 'Asc'),
  });

  return result;
};
